module.exports = __webpack_public_path__ + "media/images/lamp/yellow-27cebb5d22d97eeccfef35a180ac7bfb.png";